export const DEFAULT_MY_SITE_PAGINATION = {
  totalNumber: 0,
  resultsPerPage: 12,
  totalPages: 0,
  currentPage: 1,
  hasNext: true,
  hasPrevious: false
}

export const DEFAULT_SITE_FILTERS = {
  year: null,
  country: null,
  status: null
}
